import { render, staticRenderFns } from "./DelQuickMenu.vue?vue&type=template&id=6e4639a8&scoped=true"
import script from "./DelQuickMenu.vue?vue&type=script&lang=js"
export * from "./DelQuickMenu.vue?vue&type=script&lang=js"
import style0 from "./DelQuickMenu.vue?vue&type=style&index=0&id=6e4639a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4639a8",
  null
  
)

export default component.exports